import type { FC } from "react";
import * as React from "react";
import { ThemeProvider } from "@mui/material";
import { truffleTheme } from "@sundaysky/smartvideo-hub-truffle-component-library";

export const NewNavThemeProvider: FC = (props) => (
    <ThemeProvider theme={truffleTheme}>
        { props.children }
    </ThemeProvider>
);
